export default __webpack_public_path__ + "static/example-infinitec-693d0d0fb43848bc75a6a1992709027e.svg";